import { useEffect, useState } from "react";

const useApiWithFallback = (fetcher, fallbackData) => {
  const [data, setData] = useState(fallbackData);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [source, setSource] = useState("fallback");

  useEffect(() => {
    let active = true;

    const load = async () => {
      setLoading(true);
      setError(null);

      try {
        const apiData = await fetcher();
        const emptyArray = Array.isArray(apiData) && apiData.length === 0;

        if (!apiData || emptyArray) {
          throw new Error("API returned empty data");
        }

        if (active) {
          setData(apiData);
          setSource("api");
        }
      } catch (err) {
        if (active) {
          setData(fallbackData);
          setError(err);
          setSource("fallback");
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    load();

    return () => {
      active = false;
    };
  }, [fetcher, fallbackData]);

  return { data, loading, error, source };
};

export default useApiWithFallback;
